import "./UnverifiedBadge.css";

/** Task 5.11 — rendered when a message's citation_report.unverified is
 * true (§0.6: zero valid citations survived the one temperature=0 retry).
 * Tells the user the answer's factual claims could not be traced back to
 * a source, without hiding the answer itself. */
export default function UnverifiedBadge() {
  return (
    <span className="unverified-badge" title="This answer's claims could not be verified against the sources found.">
      ⚠ Unverified
    </span>
  );
}
